import { ComponentProps } from 'react';
import { ViewIds } from '@ardoq/api-types';
import { getRightMenuConfig } from 'viewSettings/getRightMenuConfig';
import { SettingsBar } from '@ardoq/settings-bar';
import { ExportConfigParams } from '@ardoq/view-settings';
import { viewHasLegend } from 'views/metaInfoTabs';
import { onViewSettingsUpdate } from 'tabview/onViewSettingsUpdate';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { ViewSettingsShape, ViewStreamShape } from './types';
import { getLeftMenu } from './settingsBar';
import type { I18nLocale } from '@ardoq/i18n';

const VIEW_ID = ViewIds.CAPABILITY_MAP;

type CapabilityMapSettingsBarProps = {
  legendOnClick: () => void;
  exports: ExportConfigParams;
  viewModel: ViewStreamShape;
  viewState: ViewSettingsShape;
  i18nLocale: I18nLocale;
} & Omit<
  ComponentProps<typeof SettingsBar>,
  'viewId' | 'rightMenu' | 'leftMenu' | 'i18nLocale'
>;

const CapabilityMapSettingsBar = ({
  viewModel,
  viewState,
  exports,
  legendOnClick,
  i18nLocale,
}: CapabilityMapSettingsBarProps) => (
  <div className="menuContainer">
    <SettingsBar
      viewId={VIEW_ID}
      i18nLocale={i18nLocale}
      leftMenu={getLeftMenu({ viewModel, viewState, i18nLocale })}
      rightMenu={getRightMenuConfig({
        isViewpointMode: false,
        viewId: VIEW_ID,
        viewstate: viewState,
        exports,
        withLegend: viewHasLegend(VIEW_ID),
        knowledgeBaseLink: KnowledgeBaseLink.CAPABILITY_MAP,
        legendOnClick,
        onViewSettingsUpdate,
        i18nLocale,
      })}
    />
  </div>
);

export { CapabilityMapSettingsBar };
